module.exports = __webpack_public_path__ + "img/6.fccad7ca.png";